import { t } from "i18next";

export const MY_ORGANIZATION_URL = "/auth/organization/edit";
export const DELETE_WORKSPACE_URL = "/auth/organization/delete";
export const ENGAGE_WIDGET_TRIGGER_ID = "neetoengage-trigger";

export const DEFAULT_MENU_LINK_PROPS = {
  engageProps: {
    id: ENGAGE_WIDGET_TRIGGER_ID,
    label: t("neetoMolecules.sidebar.helpLinks.whatsNew"),
    "data-testid": "help-link-engage-button",
  },
  keyboardShortcutProps: {
    label: t("neetoMolecules.sidebar.helpLinks.keyboardShortcuts"),
    "data-testid": "help-link-keyboard-shortcut-button",
  },
};

// Theme switcher
export const APP_THEME_LOCALSTORAGE_KEY = "appTheme";

export const THEMES = {
  LIGHT: "neeto-ui-theme--light",
  DARK: "neeto-ui-theme--dark",
};

// Shadcn uses `.dark` class for dark mode via @custom-variant dark (&:is(.dark *))
export const SHADCN_DARK_CLASS = "dark";

export const NEETO_AUTH_BILLING_INFO_URL =
  "/neeto_sso/api/v1/subscription/billing";
